export const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/5b008c38-7b0a-4246-8b50-04f61ebc4a75.jpg',
  boardroom: 'https://cdn.magicpatterns.com/patterns/generated-images/30a20743-47bd-4c1f-aa01-73fff44e326e.jpg',
  network: 'https://cdn.magicpatterns.com/patterns/generated-images/0c5e364f-8ef9-4dda-a41f-dcb95a508f8c.jpg',
  cta: 'https://cdn.magicpatterns.com/patterns/generated-images/18931438-e976-46a8-91a1-12664b242680.jpg',
  reception: 'https://cdn.magicpatterns.com/patterns/generated-images/db2b3eb6-10a0-4031-a4cd-419ccf9a3dfc.jpg',
}
